import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ProductsWrapper = styled.div`
  padding-bottom: ${layout.spacing.xSmall};
`;
